import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import calendar from '../../../../../assets/images/cv/calendar.svg';

export const useStyles = makeStyles(({
  breakpoints, fontWeights,
}: Theme) => ({
  header: {
    display: 'block',
    width: '100%',
    height: 'auto',
  },
  propsPaperStyles: {
    '&&': {
      paddingTop: '2rem',
      [breakpoints.up('md')]: {
        paddingTop: '3rem',
        paddingBottom: '3rem',
      },
    },
  },
  propsContentStyles: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
    '&&': {
      paddingLeft: '1rem',
      paddingRight: '1rem',
      [breakpoints.up('md')]: {
        paddingLeft: '3rem',
        paddingRight: '3rem',
      },
    },
  },
  title: {
    margin: 0,
    fontWeight: fontWeights.medium,
    fontSize: '1.25rem',
    lineHeight: 1.4,
    [breakpoints.up('md')]: {
      fontSize: '1.75rem',
      lineHeight: 1.33,
    },
  },
  uppercase: {
    textTransform: 'uppercase',
  },
  titleStyles: {
    margin: 0,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    '& p': {
      margin: 0,
    },
  },
  dates: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    paddingLeft: '3.625rem',
    background: `no-repeat url(${calendar})`,
    backgroundSize: '2.625rem auto',
  },
  footer: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '2rem',
  },
  button: {
    position: 'relative',
  },
}));
